module.exports = __webpack_public_path__ + "static-portal/img/xzz-yjjyzh.4454b7c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/xzz-yjjyzh.jpg
// module id = N9vY
// module chunks = 4